import React from 'react'
import styled from 'styled-components'
import Menu, { SubMenu, Item as MenuItem, Divider } from 'rc-menu'
import { CommomMenu } from '../controllers/Menu/CommonMenu'
import { SpreadsheetType } from '../main/options/model/types'

// Java formats mapped into JavaScript formats
export const dateFormats = {
    'dd-MM-yyyy': 'dd-mm-yyyy',
    'dd/MM/yyyy': 'dd/mm/yyyy',
    'dd/MM/yy': 'dd/mm/yy',
    'MM-dd-yyyy': 'mm-dd-yyyy',
    'MM/dd/yyyy': 'mm/dd/yyyy',
    'MM/dd/yy': 'mm/dd/yy',
    'yyyy-MM-dd': 'yyyy-mm-dd',
    'yyyy/MM/dd': 'yyyy/mm/dd',
    'dd.MM.yyyy': 'dd.mm.yyyy',
    'dd-MMM-yy': 'dd-mmm-yy',

    ddMMyyyy: 'ddmmyyyy',
    ddMMyy: 'ddmmyy',
    MMddyyyy: 'mmddyyyy',
    MMddyy: 'mmddyy',
    yyyyMMdd: 'yyyymmdd',
    yyddMM: 'yyddmm',
    yyyyddMM: 'yyyyddmm',
    yyMMdd: 'yymmdd'
}

const DecimalSeparator = ({ separator }) => <span style={{ color: 'black', fontWeight: 'bold' }}>{separator}</span>

interface IProps {
    onChange: (type: string, format: string) => void
    close: () => void
    className?: string
    format: string | undefined
    type: string
    update: boolean
}

export default function HeaderFormatOptions({ onChange, close, className, format, type, update }: IProps): JSX.Element {
    const keyToType = Object.keys(dateFormats).reduce(
        (state, key, index) => {
            return {
                ...state,
                [`type-3-${index}`]: {
                    type: SpreadsheetType.date,
                    format: key
                }
            }
        },
        {
            'type-1': {
                type: SpreadsheetType.string,
                format: ''
            },
            'type-2-1': {
                type: SpreadsheetType.number,
                format: '.'
            },
            'type-2-2': {
                type: SpreadsheetType.number,
                format: ','
            }
        }
    ) as {
        [key: string]: {
            format: string
            type: SpreadsheetType
        }
    }

    const select = ({ key }: { key: string }) => {
        const currFormat = keyToType[key]
        onChange(currFormat.type, currFormat.format)
        close()
    }

    return (
        <StyledHeaderFormatOptions>
            <CommomMenu defaultOpenKeys={[]} onClick={select} mode="vertical" triggerSubMenuAction="click">
                <MenuItem key="type-1">Text</MenuItem>
                <SubMenu title={<span className="submenu-title-wrapper">Number</span>} key="type-2">
                    <MenuItem key="type-2-1">1,000,000</MenuItem>
                    <MenuItem key="type-2-2">1.000.000</MenuItem>
                </SubMenu>
                <SubMenu title={<span className="submenu-title-wrapper">Date</span>} key="type-3">
                    {Object.keys(dateFormats).map((f, id) => (
                        <MenuItem key={`type-3-${id}`}>
                            {`${f}` === format ? <i className="fa fa-check" aria-hidden="false" /> : null}{' '}
                            {dateFormats[f]}
                        </MenuItem>
                    ))}
                </SubMenu>
            </CommomMenu>
        </StyledHeaderFormatOptions>
    )
}
const StyledHeaderFormatOptions = styled.div`
    position: absolute;
    background: var(--gray-0);
    top: 34px;
    left: 0;
    right: 0;

    div:first-of-type {
        background-color: var(--gray-0) !important;
    }
`
